<template>
  <div>
    <md-card class="pb-10 max-h-[900px]">
      <md-card-content>
        <yv-form-search
          :formSearch="formSearch"
          :inlineSearchAction="true"
          @search="search"
          v-if="isShowForm"
        >
          <template #search-actions="{ actions }">
            <div class="flex justify-between">
              <md-button
                native-type="submit"
                @click.native.prevent="actions.search"
                class="md-info md-round"
                >{{ $t("common.search") }}
              </md-button>
              <div class="flex">
                <md-button
                  v-if="isShowBtnAddLms || isShowBtnAddSis"
                  @click="showAddActivityModal"
                  class="md-primary mr-3 md-round"
                >
                  {{ $t("class.add_activity") }}
                </md-button>
                <div v-if="hasInAnySystem">
                  <action-list-button
                    :actions="bulkActions"
                  ></action-list-button>
                </div>
              </div>
            </div>
          </template>
        </yv-form-search>
        <div>
          <pdf-default
            :preview-modal="false"
            enableDownload
            pdf-content-width="1040px"
            pdf-orientation="landscape"
            ref="pdfScoreContent"
            pdf-format="letter"
            filename="export_score"
          >
            <template #pdf-content>
              <export-pdf-score
                v-if="showPdfTemplete"
                :score-pdf="scorePdf"
                :info="classInfo"
              >
              </export-pdf-score>
            </template>
          </pdf-default>
        </div>
        <!-- table for LMS system-->
        <score-table-lms-system
          v-if="shouldShowScoreTable && isLmsSystem"
          :columns="columns"
          :headerColumns="headerColumns"
          :tableData="tableData"
          :avgScore="avgScore"
          :status="status"
          :lmsName="lmsName"
          ref="tableDataLmsRef"
        ></score-table-lms-system>
        <!-- table for LMS system-->

        <!--table for SIS system-->
        <score-table-sis-system
          v-if="shouldShowScoreTable && !isLmsSystem"
          :columns="columns"
          :headerColumns="headerColumns"
          :tableData="tableData"
          :avgScore="avgScore"
          :status="status"
          ref="tableDataRef"
          @editActivityData="setEditModalActivity($event)"
        ></score-table-sis-system>
        <!--table for SIS system-->

        <div
          v-else-if="!shouldShowScoreTable"
          class="flex items-center flex-col"
        >
          <table-empty class="w-full"></table-empty>
          <div class="text-center mt-12 max-w-lg">
            <p class="font-bold text-3xl text-red-500">
              !!! {{ $t("class.note") }}
            </p>
            <p>
              {{ $t("class.note_score_list_view") }}
              <a class="cursor-pointer" @click="openScoreModal('parameter')">
                {{ $t("class.click_here") }}
              </a>
            </p>
          </div>
        </div>
      </md-card-content>
      <p
        class="pl-5 text-red-500"
        v-if="systemName === SYSTEM.SIS && statusImportScore !== 'Done'"
      >
        {{ $t("class.score_have_just_been_update") }}
      </p>
    </md-card>

    <div
      class="form-actions text-center"
      v-if="shouldShowScoreTable && $can(Class.actions.edit, Class.subject)"
    >
      <md-button class="md-raised" @click="goToPreviousPage"
        >{{ $t("common.cancel") }}
      </md-button>
      <md-button
        v-if="$can(Class.actions.edit, Class.subject)"
        :disabled="systemName === SYSTEM.SIS && statusImportScore !== 'Done'"
        class="md-success ml-4"
        @click="updateScore"
        >{{ $t("common.update") }}
      </md-button>
    </div>
  </div>
</template>

<script>
import ActionListButton from "@/components/Base/ActionListButton";
import { service_names, service_paths } from "@/constants/Services";
import { YvFormSearch } from "@/components/Base";
import size from "lodash/size";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import TableEmpty from "@/components/Base/Illustration/TableEmpty";
import Role from "@/constants/Role";
import { mapGetters } from "vuex";
import { hasValidRole } from "@/helpers/role-helper";
import { hasHistory, Message } from "@/helpers/utils";
import { Class } from "@/constants/Permissions";
import ScoreTableSisSystem from "./ScoreSis/ScoreTableSisSystem";
import ScoreTableLmsSystem from "./ScoreLms/ScoreTableLmsSystem";
import ExportPdfScore from "./ExportPdfScore";
import PdfDefault from "../../../../components/PdfDefault";

const SYSTEM = {
  SIS: "sis",
  LMS: "lms",
  EDMENTUM: "edmentum",
  AGILIX: "agilix"
};

const getColumns = (scores, type) => {
  if (isEmpty(scores)) return {};
  let columns = [];
  if (type === SYSTEM.SIS) {
    columns = map(scores.categories, item =>
      item.activities.map(activity => {
        return {
          name: activity.name,
          category_id: item.id
        };
      })
    ).flat();
  } else {
    columns = scores.activities.map(item => {
      return {
        name: item.name,
        external_id: item.external_id
      };
    });
  }
  return columns;
};
const getHeaderColumnsSis = scores => {
  let columns = [
    { name: "student" },
    { name: "final_score" },
    { name: "grade_letter" },
    { name: "current_score" }
  ];
  if (isEmpty(scores)) return columns;
  const headerColumn = map(scores.categories, item => {
    if (item.activities.length) {
      return {
        name: item.name,
        count: size(item.activities)
      };
    }
  }).filter(item => item);
  return [...columns, ...headerColumn];
};
const getHeaderColumnsLms = () => {
  return [
    { name: "student" },
    { name: "final_score_coursework" },
    { name: "grade_letter" },
    { name: "current_score" }
  ];
};

const renderStudent = student => {
  const numb = Math.random().toFixed(2) * 100000;
  const avatar_url =
    student?.avatar_url ?? `https://picsum.photos/50/50?random=${numb}`;
  return `<div class="flex items-center w-[250px]">
     <img
       src="${avatar_url}"
       class="object-cover rounded-full w-[42px] h-[42px]"/>

     <div class="text-left pl-4">
       <p class="font-medium w-full" style="word-break: break-all" title="${student?.full_name ??
         ""}">${student?.full_name ?? ""}</p>
     </div>
   </div>`;
};

const getDataTable = (scores, type, lmsName) => {
  if (isEmpty(scores)) return [];
  const dataTable = map(scores, item => {
    let data = {
      class_activity_categories: item.class_activity_categories,
      student: renderStudent(item.student),
      final_score: +item.final_score,
      final_score_coursework: +item.final_score_coursework,
      grade_letter: item?.grade_letter,
      grade_letter_coursework: item?.grade_letter_coursework,
      current_score_coursework:
        lmsName === SYSTEM.AGILIX
          ? Math.floor(+item.current_score_coursework * 100) / 100
          : +item.current_score_coursework,
      current_score:
        // agilix
        lmsName === SYSTEM.AGILIX
          ? Math.floor(+item.current_score * 100) / 100
          : +item.current_score
    };
    if (type === SYSTEM.SIS) {
      const activities = [];
      map(item.categories, category => {
        category.activities.map(i => {
          i.category_id = category.id;
          i.student_id = item._id;
          i.default_score = i.score;
        });
        activities.push(...category.activities);
      });
      data = { ...data, activities: [...activities] };
    } else {
      //edmentum
      if (lmsName === SYSTEM.EDMENTUM || lmsName === "IGS-LMS") {
        map(item.activities, activity => {
          activity.percentage_score = Math.round(+activity.percentage_score);
        });
      }
      //agilix
      if (lmsName === SYSTEM.AGILIX) {
        map(item.activities, activity => {
          activity.percentage_score =
            Math.floor(+activity.percentage_score * 100) / 100;
        });
      }
      data = { ...data, activities: [...item.activities] };
    }

    return data;
  });
  return dataTable;
};

export default {
  name: "score-list",
  components: {
    ActionListButton,
    YvFormSearch,
    TableEmpty,
    ScoreTableSisSystem,
    ScoreTableLmsSystem,
    ExportPdfScore,
    PdfDefault
  },
  inject: ["openScoreModal", "getNumberAssignStudent", "getScores"],
  props: ["scoreData", "classInfo"],
  data() {
    const classId = this.$route.params.id;
    return {
      path: `${service_paths.class_activities}/class/${classId}`,
      pathExportFile: `${service_paths.class_activities}/export/class/${classId}`,
      pathExportLink: `${service_paths.class_activities}/export/sis/class/${classId}`,
      pathUpdateScoreSis: `${service_names.school}/score/activities/class-activities/class/${classId}`,
      pathUpdateScoreLms: `${service_names.school}/class-activities/score/lms/class/${classId}`,
      formSearch: [
        {
          label: "class.student_filter_id_fullname",
          name: "search",
          value: "",
          type: "input",
          width: 50
        }
      ],
      params: {},
      classId,
      SYSTEM: SYSTEM,
      bulkActions: [],
      columns: {},
      headerColumns: [],
      tableData: [],
      avgScore: {},
      scorePdf: [],
      showPdfTemplete: false,
      showExport: false,
      status: null,
      isLmsSystem: false,
      lmsName: null,
      isUpdateValid: false,
      statusImportScore: "",
      Class,
      hasInAnySystem: true,
      modalName: "addNewActivity",
      primaryAction: {
        title: "common.add_new",
        action: ""
      },
      secondaryActions: [
        {
          title: "common.cancel",
          action: ""
        }
      ]
    };
  },
  computed: {
    ...mapGetters("user", ["role"]),
    isShowForm: function() {
      return !hasValidRole(this.role, [Role.Student, Role.Family]);
    },
    permissionAddActivity: function() {
      return (
        !hasValidRole(this.role, [Role.Student, Role.Family]) &&
        this.$can(Class.actions.edit, Class.subject)
      );
    },
    systemName() {
      return this.scoreData.systemName;
    },
    isShowBtnAddSis: function() {
      if (this.systemName === SYSTEM.SIS) {
        return this.permissionAddActivity;
      }
      return false;
    },
    isShowBtnAddLms: function() {
      if (
        this.systemName === SYSTEM.EDMENTUM ||
        this.systemName === SYSTEM.AGILIX
      ) {
        return (
          this.permissionAddActivity &&
          this.classInfo?.class_activity_categories?.length
        );
      }
      return false;
    },
    shouldShowScoreTable() {
      return this.tableData.length > 0 && this.status;
    }
  },
  methods: {
    setEditModalActivity(e) {
      this.$emit("editActivityData", e);
    },
    showAddActivityModal() {
      this.$emit("addActivityData");
    },
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    },
    setTableData() {
      const tableDataRef = this.$refs.tableDataRef.tableData;
      const listActivities = tableDataRef.map(item => item.activities);
      const listCellsChange = listActivities.map(activity => {
        if (activity.some(item => this.isBigger(item.score, item.max_point))) {
          this.isUpdateValid = true;
          return [];
        }
        return activity.filter(item =>
          this.isDifferent(item.score, item.default_score)
        );
      });
      return listCellsChange.map(lineCell => {
        if (lineCell.length) {
          return {
            id: lineCell[0].student_id,
            activities: lineCell.map(item => {
              return {
                name: item.name,
                score: item.score,
                category_id: item.category_id
              };
            })
          };
        }
      });
    },
    isBigger(value1, value2) {
      return +value1 > +value2;
    },
    isDifferent(oldVal, newVal) {
      // return +oldVal !== +newVal;
      // TODO: allow update score
      return true;
    },

    //map table data LMS
    setTableDataLms() {
      const tableDataDefault = this.$refs.tableDataLmsRef.tableDataDefaul;
      const tableData = this.$refs.tableDataLmsRef.tableData;
      const listScoreDefault = tableDataDefault.map(table =>
        table.class_activity_categories
          .map(item => item.activity_class_lms)
          .flat()
      );
      let dataUpdate = [];
      tableData.forEach((table, index) => {
        table.score_extra.forEach((scoreItem, idx) => {
          const oldVal = listScoreDefault[index][idx].score.score;
          const newVal = scoreItem.score.score;
          if (this.isDifferent(oldVal, newVal)) {
            if (this.isBigger(newVal, scoreItem.max_point)) {
              this.isUpdateValid = true;
              return [];
            }
            dataUpdate.push({
              score: newVal,
              user_id: scoreItem.score.user_id,
              activity_id: scoreItem.id
            });
          }
        });
      });
      return dataUpdate;
    },
    updateScore() {
      const systemName = this.scoreData.systemName;
      this.isUpdateValid = false;
      if (systemName === SYSTEM.EDMENTUM || systemName === SYSTEM.AGILIX) {
        this.updateScoreLms();
      }
      if (systemName === SYSTEM.SIS) {
        this.updateScoreSis();
      }
    },
    updateScoreSis() {
      const form = this.setTableData().filter(item => item);
      if (this.isUpdateValid) {
        Message.error(this.$t("class.the_score_must_be_lest_than_max_score"));
        return;
      }
      if (!form.length) return;
      this.$axios.put(this.pathUpdateScoreSis, form).then(() => {
        Message.success(this.$t("common.successfully"));
        this.getScores();
      });
    },
    updateScoreLms() {
      const form = this.setTableDataLms();
      if (this.isUpdateValid) {
        Message.error(this.$t("class.the_score_must_be_lest_than_max_score"));
        return;
      }
      this.$axios.put(this.pathUpdateScoreLms, form).then(() => {
        Message.success(this.$t("common.successfully"));
        this.getScores();
      });
    },
    search() {
      this.params = { search: this.formSearch[0].value };
    },
    exportPdf() {
      if (this.scoreData.score_lists.length) {
        this.showPdfTemplete = true;
        this.scorePdf = this.scoreData.score_lists;
        this.$refs.pdfScoreContent.generatePdf();
      } else {
        Message.error(this.$t("score_pdf.error"));
      }
    },
    exportXlsx() {
      if (this.systemName === SYSTEM.SIS) {
        this.$axios
          .get(
            this.pathExportLink,
            this.params,
            true,
            {},
            "blob",
            this.$t("class.please_import_points_before_exporting")
          )
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", this.path + ".xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
          });
      } else if (
        this.systemName === SYSTEM.EDMENTUM ||
        this.systemName === SYSTEM.AGILIX
      ) {
        this.$axios
          .get(
            this.pathExportFile,
            this.params,
            true,
            {},
            "blob",
            this.$t("class.please_enter_your_score")
          )
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", this.path + ".xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
          });
      }
    },
    injectFormData(classInfo) {}
  },
  watch: {
    params(newValue, oldValue) {
      this.getScores(newValue);
    },
    scoreData(newValue, oldValue) {
      this.avgScore = newValue?.avg_score ?? {};
      const scoreList = newValue?.score_lists;
      this.statusImportScore = newValue?.status_import_score;
      const firstItem = scoreList[0];
      if (
        newValue.systemName === SYSTEM.EDMENTUM ||
        newValue.systemName === SYSTEM.AGILIX ||
        newValue.systemName === "IGS-LMS"
      ) {
        this.isLmsSystem = true;
        this.lmsName = newValue.systemName;
        this.avgScore.current_score =
          Math.floor(+this.avgScore?.current_score * 100) / 100;
        this.columns = getColumns(firstItem, newValue.systemName);
        this.headerColumns = getHeaderColumnsLms(firstItem);
        this.tableData = getDataTable(scoreList, newValue.systemName, this.lmsName);
      } else{
        this.isLmsSystem = false;
        this.columns = getColumns(firstItem, SYSTEM.SIS);
        this.headerColumns = getHeaderColumnsSis(firstItem);
        this.tableData = getDataTable(scoreList, SYSTEM.SIS);
      }
    },
    classInfo(newValue, oldValue) {
      this.status = newValue.status;
      const lmsName = newValue.lms?.name;
      this.hasInAnySystem = [
        SYSTEM.SIS,
        SYSTEM.AGILIX,
        SYSTEM.EDMENTUM
      ].includes(lmsName);
      if (lmsName === SYSTEM.SIS) {
        this.bulkActions = [
          {
            content: "class.import_scores",
            action: () => {
              this.openScoreModal("import");
            }
          },
          {
            content: "class.export_scores_excel",
            action: () => {
              this.exportXlsx();
            }
          },
          {
            content: "class.export_scores_pdf",
            action: () => {
              this.exportPdf();
            }
          },
          {
            content: "class.parameters",
            action: () => {
              this.openScoreModal("parameter");
            }
          }
        ];
      }
      if (lmsName === SYSTEM.EDMENTUM || lmsName === SYSTEM.AGILIX) {
        this.bulkActions = [
          {
            content: "class.export_scores_excel",
            action: () => {
              this.exportXlsx();
            }
          },
          {
            content: "class.export_scores_pdf",
            action: () => {
              this.exportPdf();
            }
          },
          {
            content: "class.parameters_lms",
            action: () => {
              this.openScoreModal("parameter-lms");
            }
          }
        ];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
  margin-top: 15px;
}
</style>
